import { FC, useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import { FilterItemNode, PossibleFilterV2 } from "@/services/cloudchipr.api";
import { filterAvailableFieldsChecker } from "@/components/pages/common/filters-tree/utils/helpers/data-type-checkers/filterAvailableFieldsChecker";
import { FilterWithKey } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-key/FilterKeySelect";
import { findOptionByProviderAndKey } from "@/components/pages/common/filters-tree/utils/helpers/findOptionByProviderAndKey";
import { FilterTreeDisabledValue } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledValue";
import { FilterTreeChip } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeChip";

interface FilterTreeDisabledItemFieldsProps {
  filter: FilterItemNode;
  possibleFilters: PossibleFilterV2[];
}

export const FilterTreeDisabledItemFields: FC<
  FilterTreeDisabledItemFieldsProps
> = ({ filter, possibleFilters }) => {
  const { hasKey } = filterAvailableFieldsChecker(filter.type, filter.operator);

  const option = useMemo(() => {
    return findOptionByProviderAndKey(
      possibleFilters,
      filter.filter_provider,
      filter.type,
    );
  }, [possibleFilters, filter.filter_provider, filter.type]);

  const currentFilterOperatorLabel = useMemo(() => {
    return option?.operators?.find(
      (operator) => operator.key === filter.operator,
    )?.label;
  }, [option?.operators, filter.operator]);

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <Typography
        px="2px"
        variant="body2"
        fontWeight="medium"
        bgcolor="grey.100"
        borderRadius="2px"
        whiteSpace="nowrap"
      >
        {option?.label}
      </Typography>

      {hasKey && (
        <FilterTreeChip title={(filter as FilterWithKey).value.key ?? ""} />
      )}

      <Typography variant="body2">{currentFilterOperatorLabel}</Typography>

      <FilterTreeDisabledValue filter={filter} />
    </Stack>
  );
};
